var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.headerComponentName,{tag:"component",on:{"show":function($event){return _vm.$emit('show', $event)},"change-profile":function($event){return _vm.changeProfile()}}})}
var staticRenderFns = []

export { render, staticRenderFns }